export const SUBSCRIPTION_ONE_TIME_LICENSES = ['rbt', 'onboarding'];

// The current 'month_1' and the legacy 'monthly' value.
export const MONTHLY_BILLING_INTERVALS = ['month_1', 'monthly'];

// Add-on category keys under `subscriptionLicenses.client.addOns`. These must match the
// keys Stripe products are tagged with, so keep the raw strings centralized here rather
// than repeating them across getters and subscription UIs.
export const SUBSCRIPTION_ADD_ONS = {
  SCHEDULING: 'scheduling',
  REVENUE_CYCLE: 'revenueCycle',
  AI_NOTE_AUDITOR: 'aiNoteAuditor',
};

/*
 * Phase one of the auditor's move to paid ships the add-on, the toggle and the announcement
 * without enforcing anything, so that no organization loses access on the day it releases.
 * Turning this on is the whole of phase two, and three things move together in that one change:
 * this constant, its backend copy, and `requiresAddOn` on the learnings moderation route.
 */
export const NOTE_AUDITOR_SUBSCRIPTION_ENFORCED = false;
